import React from 'react';

export const OnboardingStepsData = {
  STEP_ONE: {
    step: 'Шаг 1',
    stepName: 'Настройте уведомления в Профиле',
    list: [
      'Откройте профиль',
      'Перейдите во вкладку “Настройка уведомлений”',
      'Настройте способы получения уведомлений и время их получения',
    ],
  },
  STEP_TWO: {
    step: 'Шаг 2',
    stepName: 'Синхронизируйте календари',
    list: [
      'Добавьте свои личные календари, чтобы контролировать свое время',
      <>
        Вы можете синхронизировать календари
        {' '}
        <a href="/onboarding/yandex">Яндекс</a>
        ,
        {' '}
        <a href="/onboarding/outlook">Outlook</a>
        ,
        {' '}
        <a href="/onboarding/google">Google</a>
        ,
        {' '}
        <a href="/onboarding/mail">Mail.ru</a>
        {' '}
        и
        {' '}
        <a href="/onboarding/thunderbird">Thunderbird</a>
      </>,
    ],
  },
  STEP_TREE: {
    step: 'Шаг 3',
    stepName: 'Создайте первую встречу',
    list: [
      'Создайте первую онлайн или офлайн встречу',
      'Пригласите коллег',
      'Уточните место проведения встречи',
    ],
  },
};
